// extracted by mini-css-extract-plugin
module.exports = {"container":"_3r1lL","header":"_3B7XB","menu":"_3AH2j"};